import { render, staticRenderFns } from "./ArvoreCard.vue?vue&type=template&id=0f3acd07&scoped=true&lang=pug"
import script from "./ArvoreCard.vue?vue&type=script&lang=js"
export * from "./ArvoreCard.vue?vue&type=script&lang=js"
import style0 from "./ArvoreCard.vue?vue&type=style&index=0&id=0f3acd07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3acd07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VProgressLinear,VSpacer,VTextField,VTreeview})
